export const clientId = 'd0b4f933-881e-46cc-bdaa-93a328f8bd58';
export const version = '1.0.9';
export const coc00nApiUrl = 'https://coc00napi-test.azurewebsites.net/api/';
export const coc00nApiScope = 'api://coc00n_api_test/read';
export const coc00nApiRedirectUrl = [...coc00nApiUrl.split('/').slice(0, 3), '.auth/login/aad'].join('/');
export const pushPublicKey = 'BA2eUp01-7u8I4euq_xIMX-zEDkU5P6nL_N9CSU5M4w-fX4c-pOoqHYcq4jm_Y2qBzCVl4aCp2q0_88UEN797m0';
